import { render, staticRenderFns } from "./HeaderBody.vue?vue&type=template&id=08938833&"
import script from "./HeaderBody.vue?vue&type=script&lang=js&"
export * from "./HeaderBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports